import styled from "styled-components";

import { fieldHorizontalPadding } from "./styles";

const srOnlyStyles = `
    position:absolute;
    left:-10000px;
    top:auto;
    width:1px;
    height:1px;
    overflow:hidden;
`;

type LabelDisplayMode = "visible" | "invisible" | "screenReaderOnly";

const Label = styled.label<
  Partial<{ $displayMode: LabelDisplayMode; $collapseLeftPadding: boolean }>
>`
  font-size: var(--textXS);
  font-weight: 600;
  letter-spacing: 1px;
  color: var(--rock);
  text-transform: uppercase;

  ${(props) =>
    !props.$collapseLeftPadding && `padding-left: ${fieldHorizontalPadding}px`};
  ${(props) => props.$displayMode === "invisible" && `opacity: 0`}
  ${(props) => props.$displayMode === "screenReaderOnly" && srOnlyStyles}
`;

export default Label;

export const LabelTitle = styled.label`
  font-size: var(--textM);
  margin-bottom: 3px;
  display: block;
  line-height: 1;
`;

export const LabelSubtitle = styled.label`
  font-size: var(--textS);
  color: var(--rock);
  line-height: 1.1;
`;

export const InputHelpText = styled.p`
  margin-top: 10px;
  font-size: var(--textXS);
  color: var(--rock);
  line-height: 1.1;
`;

export const CheckboxLabel = styled.label`
  margin: -3px 0 0 12px;
`;
